import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { CATEGORY_LABELS } from "../lib/constants";

export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="panel p-6 sticky top-24">
            <div className="flex items-center gap-2.5 pb-4 mb-2 border-b border-line">
                <span className="grid place-items-center w-7 h-7 rounded-lg bg-accent/10 text-accent">
                    <Flame size={14} />
                </span>
                <h4 className="eyebrow text-foreground">Trending Now</h4>
            </div>
            <ol className="divide-y divide-line">
                {items.map((a, i) => (
                    <li key={a.id}>
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-4 py-4"
                        >
                            <span className="font-mono text-sm font-semibold text-line-strong group-hover:text-accent transition-colors duration-150 w-6 shrink-0 pt-0.5 tabular-nums">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="min-w-0">
                                <span className="eyebrow !text-[10px] text-dim/70">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                                <h5 className="font-sans text-sm font-medium leading-snug mt-1 text-dim group-hover:text-foreground transition-colors duration-150">
                                    {a.title}
                                </h5>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="text-sm text-dim py-4">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
